module.exports = __webpack_public_path__ + "img/checked.c0cbd084.svg";